import { ref, onMounted, onUnmounted } from "vue";

/**
 * Composable для отслеживания текущего размера шрифта корневого элемента <html>.
 * Автоматически обновляет значение, если размер шрифта изменяется.
 */
export const useRootFontSize = () => {
  /**Текущий размер шрифта корневого элемента (в пикселях) */
  const rootFontSizePx = ref(16);

  /**
   * Функция для обновления размера шрифта.
   * Вызывается при изменении атрибутов <html> или событиях resize.
   */
  const updateRootFontSize = () => {
    const fontSize =
      getComputedStyle(document.documentElement)?.fontSize || "16";
    rootFontSizePx.value = parseInt(fontSize);
  };

  // Переменная для хранения экземпляра MutationObserver
  let observer: MutationObserver | null = null;

  // Обработчик, выполняется при монтировании компонента
  onMounted(() => {
    // Устанавливаем начальное значение размера шрифта
    updateRootFontSize();

    // Создаем наблюдатель для отслеживания изменений атрибутов <html>
    observer = new MutationObserver(() => {
      updateRootFontSize();
    });

    observer.observe(document.documentElement, {
      attributes: true, // Наблюдаем за изменениями атрибутов
      attributeFilter: ["style", "class"], // Следим только за style и class
    });

    // Добавляем обработчик события изменения размеров окна
    window.addEventListener("resize", updateRootFontSize);
  });

  // Обработчик, выполняется при размонтировании компонента
  onUnmounted(() => {
    // Останавливаем наблюдатель
    if (observer) {
      observer.disconnect();
    }

    // Удаляем обработчик события resize
    window.removeEventListener("resize", updateRootFontSize);
  });

  // Возвращаем реактивное значение размера шрифта
  return {
    /**Текущий размер шрифта корневого элемента (в пикселях) */
    rootFontSizePx,
  };
};
